import { UIHeading2, UIText1, UIHeading1, Button, TDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { EDeviceType } from '../../types/deviceType';

export interface IErrorComponentProps {
  deviceType: TDeviceType;
  onClick: () => void;
}

export const ErrorComponent: React.FC<IErrorComponentProps> = ({ deviceType, onClick }) => {
  const header =
    deviceType === EDeviceType.Desktop ? <UIHeading1>Рекомендации</UIHeading1> : <UIHeading2>Рекомендации</UIHeading2>;

  return (
    <div className={styles['container']} data-testid="error-component">
      <div className={styles['header']}>{header}</div>
      <div className={styles['content']}>
        <div className={styles['image']}></div>
        <div className={styles['text']}>
          <UIHeading2>Что-то пошло не так</UIHeading2>
          <UIText1 color="text-secondary-default">Попробуйте обновить или зайдите чуть позже</UIText1>
        </div>
        <Button onClick={onClick} size="M">
          Обновить
        </Button>
      </div>
    </div>
  );
};
